import { dealLines } from '../../utils/budget';
import { uid } from '../../utils/format';
import { emptyDeal } from './dealDefaults';
import { blankDealLine } from './dealLineDefaults';

/* Fiche d'une affaire : ouverture (nouvelle affaire ou affaire existante avec ses lignes). */
export default function dealOpenHandlers(deps, api) {
  const { setActivityEdit, setActivityForm, setDealActivityList, setDealModal } = deps;
  const { setDealNewProspect } = deps;

  function openDeal(aff, presetClientId) {
    setActivityForm({ type: 'Appel', date: '', etat: 'prevu', note: '' });
    setActivityEdit(null);
    setDealActivityList([]);
    setDealNewProspect(null);
    if (!aff) setDealModal(emptyDeal(presetClientId));
    else {
      const dealLineList = dealLines(aff);
      const lignes = (dealLineList.length ? dealLineList : [blankDealLine()]).map((l) => ({
        ...l,
        id: l.id === 'legacy' ? uid() : l.id,
      }));
      setDealModal({ ...aff, lignes });
    }
    if (aff && aff.id) api.loadDealActivities(aff.id);
  }

  return { openDeal, blankDealLine };
}
